import React from 'react';
import '../styles/productsbanner.css'


const ProductsBanner = () => {

    return(
        <div className='productsbanner'>
            <h1 style={{fontWeight:'600' ,width:'50%'}}>Discover Industry-Leading Robotics</h1>
            <p style={{color:'white'}}>Innovative solutions for manufacturing, healthcare, logistics, and beyond.</p>

        </div>
        
    );



}

export default ProductsBanner;



